import React from "react";
import { motion } from "framer-motion";
import { GiftIcon } from "lucide-react";
import { BONO_IMAGES } from "./data";
import { TransformButton } from "./TransformButton";
const BONOS = [{
  n: "BONO #1",
  title: "50 Casos Clínicos Resueltos",
  desc: "Aprende cómo una rehabilitadora experta analiza, planifica y resuelve los casos más complejos antes de enfrentarte a ellos en tu consultorio.",
  value: "USD $47",
  img: BONO_IMAGES.bono1
}, {
  n: "BONO #2",
  title: "Protocolo de Diagnóstico en 10 Minutos™",
  desc: "Un algoritmo práctico para evaluar rápidamente cualquier caso, detectar riesgos y tomar decisiones con mayor seguridad desde la primera consulta.",
  value: "USD $37",
  img: BONO_IMAGES.bono2
}, {
  n: "BONO #3",
  title: "Biblioteca de Errores Clínicos",
  desc: "Descubre los errores que provocan fracturas, retrabajos y complicaciones para evitarlos antes de iniciar cualquier rehabilitación.",
  value: "USD $47",
  img: BONO_IMAGES.bono3
}, {
  n: "BONO #4",
  title: "Scripts para Vender Tratamientos de Alto Valor",
  desc: "Guiones listos para presentar presupuestos, responder objeciones y transmitir el valor de tus tratamientos con mayor confianza.",
  value: "USD $37",
  img: BONO_IMAGES.bono4
}, {
  n: "BONO #5",
  title: "Pack de 30 Checklists Clínicos Profesionales",
  desc: "Una colección de checklists para cada fase del tratamiento que te ayudará a trabajar con orden, reducir errores y ganar previsibilidad.",
  value: "USD $29",
  img: BONO_IMAGES.bono5
}];
export function Bonos() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-46" data-mp="3n3e8x0nl3tdl">
      <div className="mx-auto max-w-3xl" data-id="element-47" data-mp="3i5ux07eczsot">
        <div className="text-center" data-id="element-48" data-mp="3i4ta95nzdhr9">
          <div className="mx-auto mb-3 inline-flex items-center gap-1.5 rounded-full bg-[var(--cta)]/12 px-4 py-1.5 text-xs font-bold uppercase text-[var(--cta-dark)]" data-id="element-49" data-mp="3i7yx0e9507jt">
            <GiftIcon className="h-4 w-4" data-id="element-50" data-mp="26ow9mk6s59e7" /> Bonos exclusivos gratis
          </div>
          <h2 className="font-serif-display text-2xl font-extrabold leading-tight text-gray-900 sm:text-3xl" data-id="element-51" data-mp="ys1sd3cfej5l">
            🎁 Además, HOY recibirás GRATIS estos 5 bonos exclusivos
          </h2>
          <p className="mt-3 text-sm text-gray-600" data-id="element-52" data-mp="orrhvqhrzpu4">
            Valorados en <strong data-id="element-53" data-mp="trnkblatr97k">USD $197</strong> — Hoy incluidos <strong className="text-[var(--cta-dark)]" data-id="element-54" data-mp="tqm7pce5uenq">GRATIS</strong> con tu compra.
          </p>
        </div>

        <div className="mt-8 space-y-5" data-id="element-55" data-mp="f1gf479tvmot">
          {BONOS.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 2 * 0.05
        }} className="overflow-hidden rounded-2xl border border-gray-100 bg-[var(--cream)] shadow-sm" data-id="element-56" data-mp="jurke3yzrvem" data-mpi={i}>
              {b.img && <div className="bg-white" data-id="element-57" data-mp="13hzkyjrtk7q">
                  <img src={b.img} alt={b.title} className="mx-auto w-full max-w-2xl" loading="lazy" data-id="element-58" data-mp="12gmkoj72nnd" />
                </div>}
              <div className="p-5" data-id="element-59" data-mp="3nkqrqcl6xnsh">
                <div className="mb-2 flex flex-wrap items-center gap-2" data-id="element-60" data-mp="3nltgoeyydg5r">
                  <span className="rounded-md bg-[var(--brand)] px-2.5 py-1 text-xs font-bold text-white" data-id="element-61" data-mp="3ile43pmhwcou">
                    {b.n}
                  </span>
                  <span className="rounded-md bg-[var(--cta)]/15 px-2.5 py-1 text-xs font-bold text-[var(--cta-dark)]" data-id="element-62" data-mp="e7tsdmt20z4">
                    Valor {b.value}
                  </span>
                </div>
                <h3 className="mb-1.5 text-base font-bold text-gray-900 sm:text-lg" data-id="element-63" data-mp="a88brg36r0p9">{b.title}</h3>
                <p className="text-sm leading-relaxed text-gray-600" data-id="element-64" data-mp="593yoed54itn">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <TransformButton label="Quiero los 5 bonos gratis" data-id="element-65" data-mp="f602i6s3ggrv" />
      </div>
    </section>;
}